import { FC, ReactNode } from 'react';

interface FilterFieldProps {
  label: string;
  children: ReactNode;
}

const FilterField: FC<FilterFieldProps> = ({ label, children }) => (
  <div>
    <label className="mb-1 block text-xs font-medium text-inkMuted dark:text-inkMuted-dark">
      {label}
    </label>
    {children}
  </div>
);

export default FilterField;
